import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import common from "./locales/en/common.json";
import commonRo from "./locales/ro/common.json";

/**
 * The portal's single translation catalogue (`QR-04`, `PD-18`). English is the default
 * and fallback language; Romanian is also available.
 */
void i18n.use(initReactI18next).init({
  resources: {
    en: { common },
    ro: { common: commonRo },
  },
  lng: "en",
  fallbackLng: "en",
  defaultNS: "common",
  ns: ["common"],
  interpolation: {
    // React already escapes rendered output.
    escapeValue: false,
  },
  returnNull: false,
});

export default i18n;
